export const VISUAL_REDUCER_VERSION = '2.0.0';

export const VisualCommandType = Object.freeze({
  COMMIT_THEME: 'visual/commit-theme',
  RESET: 'visual/reset',
});

const frozenRecord = (value = {}) => Object.freeze({ ...value });

export const initialVisualState = Object.freeze({
  version: 'visual-light',
  reducerVersion: VISUAL_REDUCER_VERSION,
  publisher: 'VisualAuthority',
  command: VisualCommandType.RESET,
  themeVersion: 'theme-light',
  mode: 'light',
  accessible: true,
  semanticPalette: frozenRecord(),
  surfaceHierarchy: frozenRecord(),
  typographyTokens: frozenRecord(),
  interactiveTokens: frozenRecord(),
  borderTokens: frozenRecord(),
  elevationTokens: frozenRecord(),
  motionTokens: frozenRecord(),
  variables: frozenRecord(),
});

const tokenGroup = (variables, predicate) => frozenRecord(Object.fromEntries(
  Object.entries(variables).filter(([token]) => predicate(token)),
));

const reduceTheme = (theme = {}) => {
  const variables = frozenRecord(theme.variables);
  const version = theme.version || 'visual-unversioned';
  return Object.freeze({
    version,
    reducerVersion: VISUAL_REDUCER_VERSION,
    publisher: 'VisualAuthority',
    command: VisualCommandType.COMMIT_THEME,
    themeVersion: version,
    mode: theme.mode || 'light',
    accessible: theme.validation?.accessible !== false,
    semanticPalette: frozenRecord(theme.surface),
    surfaceHierarchy: tokenGroup(variables, (token) => token.startsWith('--og-level-')),
    typographyTokens: tokenGroup(variables, (token) => token.startsWith('--og-text-') || token.startsWith('--og-typography-') || token.startsWith('--og-font-') || token.startsWith('--og-line-height-')),
    interactiveTokens: tokenGroup(variables, (token) => token.startsWith('--og-button-') || token.startsWith('--og-control-') || token.startsWith('--og-state-') || token.startsWith('--og-action-')),
    borderTokens: tokenGroup(variables, (token) => token.includes('border')),
    elevationTokens: tokenGroup(variables, (token) => token.includes('shadow') || token.includes('elevation')),
    motionTokens: tokenGroup(variables, (token) => token.includes('motion') || token.includes('duration') || token.includes('ease')),
    variables,
  });
};

export const visualStateReducer = (state = initialVisualState, command = {}) => {
  if (command.type === VisualCommandType.RESET) return initialVisualState;
  if (command.type === VisualCommandType.COMMIT_THEME) return reduceTheme(command.theme);
  return state;
};

export default visualStateReducer;
